import uuidv4 from 'uuid/v4';

import { Telemetry } from '../../commonInfra/services/Telemetry';
import { SearchNoResultEvent, TelemetryEvents, SearchInitiatedEvent, SearchTermUpdatedEvent, SearchResultClickedEvent, SearchEventSource } from '../../common/telemetryEvents/TelemetryEvents';

interface ISearchTelemetry {
  clearSearchFlowId: () => void;
  startSearchFlow: (eventSource: SearchEventSource) => void;
  isSearchFlowStarted: () => boolean;
  sendSearchTermUpdatedEvent: (eventSource: SearchEventSource, searchTerm: string) => void;
  endSearchFlowWithNoResultEvent: (eventSource: SearchEventSource, searchTerm: string) => void;
  sendSearchResultClickedEvent: (event: Omit<SearchResultClickedEvent, 'searchFlowId'>) => void;
  ensureInitialization: (isOnlineEnvironemnt: boolean) => void;
}

class SearchTelemetry implements ISearchTelemetry {
  private isOnlineEnvironemnt = false;
  private searchFlowId: string = '';

  public ensureInitialization = (isOnlineEnvironemnt: boolean) => {
    this.isOnlineEnvironemnt = isOnlineEnvironemnt;
  }

  public startSearchFlow = (eventSource: SearchEventSource) => {
    this.searchFlowId = uuidv4();

    Telemetry.sendEvent<SearchInitiatedEvent>({
      type: TelemetryEvents.SearchInitiated,
      eventSource,
      searchFlowId: this.searchFlowId
    });
  }

  public clearSearchFlowId = () => {
    this.searchFlowId = '';
  }

  public isSearchFlowStarted = () => {
    return this.searchFlowId !== '';
  }

  public sendSearchTermUpdatedEvent = (eventSource: SearchEventSource, searchTerm: string) => {
    if (!this.isOnlineEnvironemnt) {
      searchTerm = null;
    }

    Telemetry.sendEvent<SearchTermUpdatedEvent>({
      type: TelemetryEvents.SearchTermUpdated,
      eventSource,
      searchTerm,
      searchFlowId: this.searchFlowId
    });
  };

  public endSearchFlowWithNoResultEvent = (eventSource: SearchEventSource, searchTerm: string) => {
    if (!this.isOnlineEnvironemnt) {
      searchTerm = null;
    }

    if (this.searchFlowId === '') { return; }
    Telemetry.sendEvent<SearchNoResultEvent>({
      type: TelemetryEvents.SearchNoResult,
      eventSource,
      searchTerm,
      searchFlowId: this.searchFlowId
    });
    this.clearSearchFlowId();
  }

  public sendSearchResultClickedEvent = (event: Omit<SearchResultClickedEvent, 'searchFlowId'>) => {
    if (!this.isOnlineEnvironemnt) {
      event.searchTerm = null;
    }
    Telemetry.sendEvent<SearchResultClickedEvent>({ ...event, searchFlowId: this.searchFlowId });
    if (!event.seeAll) {
      this.clearSearchFlowId();
    }
  }
}

export const searchTelemetry: ISearchTelemetry = new SearchTelemetry();
